import { LongGameError } from '@long-game/common';
import { hcWithType as apiHc } from '@long-game/service-api/client';
import { publicSdk } from '../api/index.js';
import { API_ORIGIN } from '../config.js';
import { fetch } from '../fetch.js';
export const apiRpc = apiHc(API_ORIGIN, {
    fetch,
});
export async function getSummary(gameSessionId) {
    return publicSdk.getGameSessionDetails.run({ id: gameSessionId });
}
export async function getPlayers(gameSessionId) {
    return publicSdk.getGameSessionMembers.run({ id: gameSessionId });
}
export async function startGame(gameSessionId) {
    return publicSdk.run(publicSdk.startGameSession, { id: gameSessionId });
}
export async function resolveGameId(gameIdOrAlias) {
    return publicSdk.getResolvedGameIdFromAlias.run({ aliasId: gameIdOrAlias });
}
export async function getPublicRound(gameSessionId, roundIndex) {
    const res = await publicSdk.getGameSessionRound.run({
        id: gameSessionId,
        index: roundIndex,
    });
    return res;
}
export async function getPostgame(gameSessionId) {
    return publicSdk.getGameSessionPostgame.run({ id: gameSessionId });
}
// only works in DEV_MODE. returns raw private turn data
export async function getDevModeTurns(gameSessionId) {
    const res = await apiRpc.gameSessions[':id'].turns.$get({
        param: { id: gameSessionId },
    });
    if (!res.ok) {
        throw new LongGameError(LongGameError.Code.Unknown, 'Failed to get turns');
    }
    return await res.json();
}
//# sourceMappingURL=api.js.map